import { PromotionEntityType, getCurrencySymbol } from '@jove-frontend/uikit';

export const judgeWhetherAllowQuoteMonthlyPayment = (price, promotionInfo?: any) => {
  if (![PromotionEntityType.BROKER_PROMOTION].includes(promotionInfo?.promotionType)) {
    return true;
  }

  const minAmount = promotionInfo?.payload?.payment_settings?.monthly_payment_min_amount;
  if (!minAmount && minAmount !== 0) {
    return true;
  }

  return Number(price?.aggregate_prices?.total ?? 0) >= Number(minAmount);
};

export const getQuoteDisplayCurrencySymbol = (stateData) => {
  return stateData?.price?.currency ? getCurrencySymbol(stateData?.price?.currency) : stateData?.currency?.symbol;
};

export const saveHomePageUrlParamsInfo = (data) => {
  if (!!data) {
    sessionStorage.setItem('Jove-quote-home-url-params', JSON.stringify(data));
  } else {
    sessionStorage.removeItem('Jove-quote-home-url-params');
  }
};

export const getHomePageUrlParamsInfo = () => {
  let data = null;
  try {
    data = JSON.parse(sessionStorage.getItem('Jove-quote-home-url-params'));
  } catch (_) {}

  return data;
};

export const judgeWhetherNeedToCleanPageDataToEdit = (stateData, pageKey) => {
  return stateData.temporaryFieldMap?.isFromValidationAssumptionCreate && !stateData.temporaryFieldMap?.haveSavePageMap?.[pageKey];
};
